const AOS = require('aos');
const $ = require('jquery');
// const _ = require('lodash');

require('@popperjs/core');
require('bootstrap');
require('slick-carousel');

window.jQuery = $;

$(function () {
  loadAOS();
  initSliders();
  initGoogleMapping();
  containerFix();
  submenuOffset();
  heroOffset();
  headerFix();

  /* Automatically updates path names for local development */
  if (window.location.hostname === 'ironandvelvet' || window.location.hostname === 'localhost') {
    universal_path_change('ironandvelvet', 'ironandvelvet');
  }

  $('.subscription_details tbody tr td').each(function() {
    if ($(this).text().trim() === 'Actions') {
      $(this).siblings('td').append('<a class="button shop" href="/shop/">Shop products</a>');
    }
  });

  //Move subscription content to show before product description
  const addToSubscription = document.querySelector('.jgtb-add-to-subscription');
  const productDescription = document.querySelector('.woocommerce-product-description');
  if (addToSubscription && productDescription) {
    const parent = productDescription.parentNode;
    parent.insertBefore(addToSubscription, productDescription);
  }//if

  // handler for the resize window event
  $(window).on("resize", function () {
    containerFix();
    headerFix();
  });
  // handler for the scroll window event
  $(window).on("scroll", function () {
    checkWindowScroll();
    uncoverElements();
  });

  //Header search form
  document.getElementById('headerMagnifyingGlass').addEventListener('click', function(ev) {
    document.getElementById('headerSearchForm').classList.toggle('hidden');
    document.getElementById('headerSearchFormInput').focus();
  });

  // This adds margin top to first section tag inside body
  function headerFix() {
    let header = $("header");
    let headerHeight = $(header).outerHeight();
    var firstSection = $('body').find('section').first();
    $(firstSection).css("margin-top", `${headerHeight}px`);
    document.getElementById('headerSearchForm').style.top = `${headerHeight}px`;
  }
  
  // Smooth scroll.
  $('a[href*="#"]')
    .not('[href="#"]')
    .not('[href="#0"]')
    .on("click", function (event) {
      if (
        location.pathname.replace(/^\//, "") ==
          this.pathname.replace(/^\//, "") &&
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        var offset = $("header").outerHeight();
        target = target.length
          ? target
          : $("[name=" + this.hash.slice(1) + "]");
        if (target.length) {
          event.preventDefault();
          $("html, body").animate(
            {
              scrollTop: target.offset().top - offset,
            },
            1000
          );
        }
      }
    });

  // Burger click
  $("#burger").click(function () {
    open = !open;
    toggleMenu(open);
  });

  // Active class.
  $("header .nav [href]").each(function () {
    if (this.href == window.location.href) {
      $(this).addClass("active");
    }
  });

  // Submenu.
  $(".submenu-toggle").on("click", function () {
    var toggle = $(this);
    toggle.toggleClass("open");
    $(this).prev(".parent-item").toggleClass("open");
    var submenu = $(this).next(".submenu");
    submenu.children("ul").slideToggle("fast");
  });

  $.fn.isScrolledIntoView = function () {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();
    var elemTop = $(this).offset().top;
    return elemTop <= docViewBottom && elemTop >= docViewTop;
  };

  // Get video elements
  const videos = document.querySelectorAll('.socialsSlider video');
  const playButton = document.getElementById('playButton');

  let currentIndex = 0;
  const slides = document.querySelectorAll('.socialsSlider .slide');
  const slidesContainer = document.querySelector('.socialsSlider .slides');

  // Function to move to the next video
  function nextSlide() {
    currentIndex = (currentIndex + 1) % videos.length; // Loop to the first video after the last one
    slidesContainer.style.transform = `translateX(-${currentIndex * 100}%)`; // Move the whole container
    videos[currentIndex].play(); // Play the next video automatically
  }

  // Event listeners for each video to detect when they end
  videos.forEach((video, index) => {
    video.addEventListener('ended', () => {
      if (index === currentIndex) {
        nextSlide();
      }
    });
  });

  // Start playing the first video
  if (playButton) {
    playButton.addEventListener('click', () => {
      videos[currentIndex].play();
      playButton.style.display = 'none'; // Hide the play button after the video starts
    });
  }//if
  
  const addToSubscriptionForm = document.querySelector('.jgtb-add-to-subscription');
  if (addToSubscriptionForm) {
    addToSubscriptionForm.insertAdjacentHTML('beforebegin', '<div id="subscriptionORText" class="my-3"><p class="h3 mb-0 text-center">OR</p></div>');
  }//if

  // Check if the element exists
  if ($('.wcsatt-options-prompt-label-subscription').length) {
    // Append your custom text
    $('.wcsatt-options-prompt-label-subscription').append(' <span class="subscriptionCustomText small"><i class="fa-solid fa-check text-white me-3"></i>Cancel or pause Online at anytime</span>');
  }//if

  // Add custom text next to Change Subscription button
  if ($('.wcs-switch-link').length) {
    $('.wcs-switch-link').after('<br><small style="font-style: italic; color: #666; margin-top: 5px; display: block;">To update your subscription duration; you will have to go through the checkout process again but you will not be charged until your subscription renewal date.</small>');
  }//if
    
  //Faqs sections show/hide
  faqSectionTitles = document.querySelectorAll('.faqsSectionTitle');
  if (faqSectionTitles.length > 0) {

    //Go through all titles and if one is clicked show the correct section on the right
    for (faqSectionTitle of faqSectionTitles) {
      faqSectionTitle.addEventListener('click', (ev) => {
        mainSection = document.getElementById('faqsSectionQuestions' + ev.target.getAttribute('data-attribute-section'));
        mainTitle = document.getElementById('faqsSectionTitle' + ev.target.getAttribute('data-attribute-section'));

        //Get all .faqsSectionQuestion and titles and remove class of active
        faqSectionQuestions = document.querySelectorAll('.faqsSectionQuestion');
        faqSectionTitles = document.querySelectorAll('.faqsSectionTitle');

        for (section of faqSectionQuestions) {
          section.classList.remove('active');
        }//for
        
        for (title of faqSectionTitles) {
          title.classList.remove('active');
        }//for

        //Add classes to correct ids
        mainSection.classList.add('active');
        mainTitle.classList.add('active');

      });
    }//for

  }//if

});

/**
 * @description loads the AOS library after a set timeout
 */
let loadAOS = () => {
  setTimeout(() => {
    $("body").addClass("loaded");
    setTimeout(() => {
      AOS.init();
    }, 500);
  }, 1000);
};

/**
 * @description checks the scroll value of the window and adds a class to the header if the window is scrolled
 */
let checkWindowScroll = () => {
  let scroll = $(window).scrollTop();
  if (scroll > 0) {
    $("header").addClass("scroll");
  } else {
    $("header").removeClass("scroll");
  }
};

/**
 * @description function for fixing floating elements or page width elements with content to the conventional bootstrap container sizes
 */
let containerFix = () => {
  if ($('.container-fix').length) {
    let containerWidths = {
      576: 540,
      768: 720,
      992: 960,
      1200: 1140,
      1440: 1440,
    };
    let windowWidth = $(window).width();
    let containerWidth = 0;
    for (const [key, value] of Object.entries(containerWidths)) {
      if (windowWidth >= key) {
        containerWidth = value;
      }
    }

    var padding = ((windowWidth - containerWidth) / 2) + 32;
    if (windowWidth >= 992) {
      $('.container-fix').each(function () {
        if ($(this).hasClass('odd')) {
          $(this).css('padding-left', '0px');
          $(this).css('padding-right', padding + 'px');
        } else if ($(this).hasClass('even')) {
          $(this).css('padding-left', padding + 'px');
          $(this).css('padding-right', '0px');
        }
      });
    } else if (windowWidth >= 576 && windowWidth <= 991) {
      $('.container-fix').each(function () {
        $(this).css('padding-left', padding + 'px');
        $(this).css('padding-right', padding + 'px');
      });
    } else {
      $('.container-fix').each(function () {
        $(this).css('padding-left', '32px');
        $(this).css('padding-right', '32px');
      });
    }
  }
};

/**
 *  @description affix appropriately css positioned elements (ie position = fixed || absolute) below the header banner
 */
let submenuOffset = () => {
  let headerHeight = $("#header").outerHeight();
  let dropdown = $(".submenu");
  let scroll = $(document).scrollTop();
  let topstripHeight = 0;

  if (scroll == 0) {
    dropdown.css("top", headerHeight + "px");
  } else if (scroll < topstripHeight) {
    dropdown.css("top", scroll + headerHeight + "px");
  } else {
    dropdown.css("top", headerHeight + "px");
  }
};

/**
 * @description offset elements labeled with the offset hero class by the height of the header
 */
let heroOffset = () => {
  let hero = $(".offset-hero");
  let header = $("header");

  if (hero.length && header.length) {
    let height = $(header).outerHeight();
    $(hero).css("margin-top", `${height}px`);
  }
};

/**
 * @description reveals hidden page elements
 */
let uncoverElements = () => {
  $(".uncover").each(function () {
    if ($(this).isScrolledIntoView() === true) {
      $(this).addClass("show");
    }
  });
};

/**
 * @description initialise the slick sliders for the page
 */
let initSliders = () => {
  // generic slider example
  // go to - https://kenwheeler.github.io/slick/ - for documentation
  $(".slider").slick({
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToScroll: 1,
    slidesToShow: 1,
  });

  $(".announcementsSlider").slick({
    dots: false,
    arrows: false,
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: true,
    // mobileFirst: true,
    autoplay: true,
    autoplaySpeed: 0,
    pauseOnHover: false,
    pauseOnFocus: false,
    pauseOnDotsHover: false,
    cssEase: 'linear',
    variableWidth: true,
    speed: 8000,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 3,
        }
      },
    ],
  });
  
  $(".videosContainerMobile").slick({
    dots: false,
    arrows: false,
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: true,
    
  });

  $(".testimonialSlider").slick({
    dots: false,
    arrows: true,
    slidesToScroll: 1,
    slidesToShow: 2,
    infinite: true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
        }
      }
    ],
    prevArrow: '<button class="slick-arrow slick-prev" type="button"></button>',
    nextArrow: '<button class="slick-arrow slick-next" type="button"></button>'
  });

  $(".blog-post-carousel").slick({
    dots: false,
    arrows: true,
    autoplay: false,
    infinite: false,
    slidesToScroll: 1,
    slidesToShow: 4,
    // mobileFirst: true,
    responsive: [
      {
        breakpoint: 1450,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1
        }
      },
    ],
    prevArrow: '<button class="slick-arrow slick-prev" type="button"></button>',
    nextArrow: '<button class="slick-arrow slick-next" type="button"></button>'
  });

  $(".product-carousel").slick({
    dots: false,
    arrows: true,
    autoplay: false,
    infinite: false,
    slidesToScroll: 1,
    slidesToShow: 4,
    //mobileFirst: true,
    responsive: [
      {
        breakpoint: 1450,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1
        }
      },
    ],
    prevArrow: '<button class="slick-arrow slick-prev" type="button"></button>',
    nextArrow: '<button class="slick-arrow slick-next" type="button"></button>'
  });
  
  $(".category-card-carousel").slick({
    dots: false,
    arrows: true,
    autoplay: false,
    infinite: false,
    slidesToScroll: 1,
    slidesToShow: 3,
    // mobileFirst: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1
        }
      },
    ],
    prevArrow: '<button class="slick-arrow slick-prev" type="button"></button>',
    nextArrow: '<button class="slick-arrow slick-next" type="button"></button>'
  });
};

/**
 * @description handles opening and closing of the mobile menu on the site
 *
 * @param {*} open flag indicating whether or not the menu is in an open state
 */
var open = false;
let toggleMenu = (open) => {
  $("#burger").toggleClass("open", open);
  $("#navigation-mobile ul").toggleClass("open", open);
};

/**
 * @description centers the map on the current marker or in the center of all markers present
 *
 * @param {*} map the JSON map object being worked on
 */
let centerMap = (map) => {
  let bounds = new google.maps.LatLngBounds();
  $.each(map.markers, function (i, marker) {
    let latlng = new google.maps.LatLng(
      marker.position.lat(),
      marker.position.lng()
    );
    bounds.extend(latlng);
  });
  if (map.markers.length == 1) {
    map.setCenter(bounds.getCenter());
    map.setZoom(map.zoom);
  } else {
    map.fitBounds(bounds);
  }
};

/**
 * @description adds a new marker to the map being created
 *
 * @param {*} $marker the jQuery HTML marker to be added
 * @param {*} map the JSON map object to be operated on
 */
let addMarker = ($marker, map) => {
  let latlng = new google.maps.LatLng(
    $marker.attr("data-lat"),
    $marker.attr("data-lng")
  );
  let icon = {
    url: "" + $marker.attr("data-icon") + "",
    scaledSize: new google.maps.Size(48, 48),
  };
  let marker = new google.maps.Marker({
    icon: icon,
    map: map,
    position: latlng,
  });
  map.markers.push(marker);
  if ($marker.html()) {
    let infowindow = new google.maps.InfoWindow({
      content: $marker.html(),
    });
    google.maps.event.addListener(marker, "click", function () {
      infowindow.open(map, marker);
    });
  }
};

/**
 * @description creates a new map at the location of the jQuery element passed in
 *
 * @param {*} $el the jQuery element to create a map aroudn
 */
let newMap = ($el) => {
  let $markers = $el.find(".marker");
  let args = {
    center: new google.maps.LatLng(0, 0),
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    styles: [
      {
        featureType: "water",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#d3d3d3",
          },
        ],
      },
      {
        featureType: "transit",
        stylers: [
          {
            color: "#808080",
          },
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [
          {
            visibility: "on",
          },
          {
            color: "#b3b3b3",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#ffffff",
          },
        ],
      },
      {
        featureType: "road.local",
        elementType: "geometry.fill",
        stylers: [
          {
            visibility: "on",
          },
          {
            color: "#ffffff",
          },
          {
            weight: 1.8,
          },
        ],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [
          {
            color: "#d7d7d7",
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "geometry.fill",
        stylers: [
          {
            visibility: "on",
          },
          {
            color: "#ebebeb",
          },
        ],
      },
      {
        featureType: "administrative",
        elementType: "geometry",
        stylers: [
          {
            color: "#a7a7a7",
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#ffffff",
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#ffffff",
          },
        ],
      },
      {
        featureType: "landscape",
        elementType: "geometry.fill",
        stylers: [
          {
            visibility: "on",
          },
          {
            color: "#efefef",
          },
        ],
      },
      {
        featureType: "road",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#696969",
          },
        ],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [
          {
            visibility: "on",
          },
          {
            color: "#737373",
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "labels.icon",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "labels",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [
          {
            color: "#d6d6d6",
          },
        ],
      },
      {
        featureType: "road",
        elementType: "labels.icon",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {},
      {
        featureType: "poi",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#dadada",
          },
        ],
      },
    ],
    zoom: 12,
  };
  let map = new google.maps.Map($el[0], args);
  map.markers = [];
  $markers.each(function () {
    addMarker($(this), map);
  });
  centerMap(map);
  return map;
};

/**
 * @description convenience function for running all code required to generate a single (or multiple) maps on a page
 */
let initGoogleMapping = () => {
  $(".map").each(function () {
    newMap($(this));
  });
};

/**
 * @name universal_path_change
 * @description update paths appropriately during development
 */
let universal_path_change = (liveDomain, localDomain) => {
  const live = liveDomain;
  const local = localDomain;

  // Replace domain in <img> src attributes
  $('img').each(function () {
    const currentSrc = $(this).attr('src');

    // Update test domain
    if (currentSrc && currentSrc.includes(local + '.test')) {
      $(this).attr('src', currentSrc.replace(local + '.test', live + '.co.uk'));
    }

    // Update local domain
    if (currentSrc && currentSrc.includes('localhost:3000')) {
      $(this).attr('src', currentSrc.replace('localhost:3000', live + '.co.uk'));
    }
  });

  // Replace domain in <video> src attributes
  $('video').each(function () {
    const currentSrc = $(this).attr('src');
    const currentPoster = $(this).attr('poster');

    // Update test domain
    if (currentSrc && currentSrc.includes(local + '.test')) {
      $(this).attr('src', currentSrc.replace(local + '.test', live + '.co.uk'));
    }

    if (currentPoster && currentPoster.includes(local + '.test')) {
      $(this).attr('poster', currentPoster.replace(local + '.test', live + '.co.uk'));
    }

    // Update local domain
    if (currentSrc && currentSrc.includes('localhost:3000')) {
      $(this).attr('src', currentSrc.replace('localhost:3000', live + '.co.uk'));
    }

    if (currentPoster && currentPoster.includes('localhost:3000')) {
      $(this).attr('poster', currentPoster.replace('localhost:3000', live + '.co.uk'));
    }
  });

  // Replace domain in <div> background-image style attributes
  $('div').each(function () {
    const currentBg = $(this).css('background-image');

    // Update test domain
    if (currentBg && currentBg.includes(local + '.test')) {
      const updatedBg = currentBg.replace(local + '.test', live + '.co.uk');
      $(this).css('background-image', updatedBg);
    }

    // Update local domain
    if (currentBg && currentBg.includes('localhost:3000')) {
      const updatedBg = currentBg.replace('localhost:3000', live + '.co.uk');
      $(this).css('background-image', updatedBg);
    }
  });

  // Replace domain in <a> src attributes
  $('a').each(function () {
    const currentSrc = $(this).attr('href');

    // Update test domain
    if (currentSrc && currentSrc.includes(live + '.co.uk') && window.location.hostname === local + '.test') {
      $(this).attr('href', currentSrc.replace(live + '.co.uk', local + '.test'));
    }

    // Update test domain
    if (currentSrc && currentSrc.includes(live + '.co.uk') && window.location.hostname === 'localhost') {
      $(this).attr('href', currentSrc.replace(live + '.co.uk', 'localhost:3000'));
    }
  });
};